import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
import moment from "moment";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import "@/EditDialog.scss";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "KisFacilityEditDialog",
  components: { LogOverview, ValidationDialog, TreeViewSelection },
  props: ["editDialog", "editedItem", "departments"],
  data: () => ({
    errorDialog: false,
    errorList: [],
    step: 1
  }),
  mounted() {},
  methods: {
    close() {
      this.$refs?.logOverview?.resetLogs();
      this.$emit("closeDialog");
    },
    addDepartment(value) {
      this.editedItem.departments = value;
    },
    getNiceDateTime(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
    userById(id) {
      if (!id) return "";
      const user = this.users.find(u => u.id === id || u._id === id);
      if (user?.first_name && user?.last_name)
        return `${user.first_name} ${user.last_name}`;
      else return null;
    },
    checkValid() {
      const form = this.$refs.facilityAreaEditForm;
      form.validate();
      const invalidFields = form._data.inputs.filter(i => !i.valid);
      this.errorList = [];
      invalidFields.forEach(field => {
        this.errorList.push({
          field: field?.$vnode?.componentOptions?.propsData?.label?.replace(
            "*",
            ""
          ),
          validations: field.validations
        });
      });
      if (this.errorList.length) this.errorDialog = true;

      if (this.errorList.length === 0) {
        return true;
      }
      return false;
    },
    async save(close = false) {
      if (this.editedItem._id) {
        await this.updateFacility();
      } else {
        await this.createFacility();
      }

      const logsFetched = this.$refs?.logOverview?.logsFetched;
      this.$refs?.logOverview?.resetLogs();

      if (close) {
        this.close();
      } else if (logsFetched) {
        await this.$refs?.logOverview?.getLogs();
      }
    },
    async createFacility() {
      try {
        const headers = getTokenHeader();
        if (!this.editedItem.principal_id)
          this.editedItem.principal_id = this.currentPrincipal;
        const response = await axios.post(
          `${env.kis_api_client_url}facility`,
          this.editedItem,
          {
            headers
          }
        );
        if (response.status === 201) {
          this.$emit("setFacility", response.data);
          await this.$store.dispatch("createSuccess", "Erfolgreich erstellt");
          await this.$store.dispatch("getFacilities", this.filter);
        } else {
          console.error(response);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch(
          "createError",
          "Es ist ein Fehler aufgetreten!"
        );
      }
    },
    async updateFacility() {
      try {
        await this.$emit("updateFacility", this.editedItem);
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    users() {
      return this.$store.state.users;
    },
    logUrl() {
      return `${env.kis_api_client_url}log/${this.editedItem._id}`;
    }
  }
};
